import PropTypes from 'prop-types';
import React from 'react';
import { useFormContext } from '../withFormContext';
function withForm(WrappedComponent) {
    const WithForm = (props)=>{
        const { formName, disabled } = useFormContext();
        return /*#__PURE__*/ React.createElement(WrappedComponent, {
            disabled: disabled,
            formName: formName,
            ...props
        });
    };
    WithForm.contextTypes = {
        formName: PropTypes.string,
        disabled: PropTypes.bool
    };
    return WithForm;
}
export default withForm;
